import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth";
import { supabase } from "@/integrations/supabase/client";

/**
 * Gates access to the internal /admin panel.
 *
 * Mirrors the backend gate in `admin-dashboard` exactly: the user must have a
 * `super_admin` row in `user_roles`. Email domain alone is not sufficient and
 * the two gates cannot drift.
 */
export function useSorvaineAdmin() {
  const { user, loading: authLoading } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["sorvaine-admin", user?.id],
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_roles")
        .select("id")
        .eq("user_id", user!.id)
        .eq("role", "super_admin")
        .maybeSingle();
      if (error) return false;
      return !!data;
    },
  });

  return {
    isSorvaineAdmin: !!data,
    isLoading: authLoading || (!!user?.id && isLoading),
  };
}
